import { ProVatRegime } from '../vat';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_VAT_REGIME = 'PRO_VAT_REGIME_';

/** Libellés affichés dans le sélecteur admin. */
export const ProVatRegimeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.UNDETERMINED}`]: 'À arbitrer',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.FR_METROPOLE}`]: 'France métropolitaine (20 %)',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.DOM_LOCAL_VAT}`]: 'DOM, TVA locale (8,5 %)',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.DOM_REVERSE_CHARGE}`]: 'DOM, autoliquidation (0 %)',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.EXEMPT_CGI_294}`]: 'TVA non applicable, art. 294-1 (0 %)',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.EU_REVERSE_CHARGE}`]: 'UE, autoliquidation B2B (0 %)',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME}${ProVatRegime.OUT_OF_SCOPE_NON_EU}`]: 'Hors UE, hors champ (0 %)',
  },
};

export const TRANSLATE_KEY_PRO_VAT_REGIME_MENTION = 'PRO_VAT_REGIME_MENTION_';

/**
 * Mention légale imprimée sur la facture émise au pro. Chaîne vide = aucune mention à ajouter
 * (métropole : le taux parle de lui-même ; régime non tranché : aucune facture n'est émise).
 *
 * Ces textes sont ceux qui justifient un taux à 0 % : les modifier engage la conformité des
 * factures déjà émises comme des suivantes.
 */
export const ProVatRegimeMentionTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.UNDETERMINED}`]: '',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.FR_METROPOLE}`]: '',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.DOM_LOCAL_VAT}`]:
      'TVA au taux normal applicable en Guadeloupe, en Martinique et à La Réunion (art. 296 du CGI).',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.DOM_REVERSE_CHARGE}`]:
      'Autoliquidation : TVA due par le preneur (art. 283-1 du CGI).',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.EXEMPT_CGI_294}`]:
      'TVA non applicable (art. 294-1 du CGI).',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.EU_REVERSE_CHARGE}`]:
      'Autoliquidation : TVA due par le preneur (art. 196 de la directive 2006/112/CE).',
    [`${TRANSLATE_KEY_PRO_VAT_REGIME_MENTION}${ProVatRegime.OUT_OF_SCOPE_NON_EU}`]:
      'Opération non soumise à la TVA française : prestation localisée hors de France (art. 259-1 du CGI).',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(ProVatRegime, ProVatRegimeTranslation, TRANSLATE_KEY_PRO_VAT_REGIME, true);
validateEnumTranslations(ProVatRegime, ProVatRegimeMentionTranslation, TRANSLATE_KEY_PRO_VAT_REGIME_MENTION, true);
